module.exports = __webpack_public_path__ + "static/media/05.77ad1d82.png";